<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qcYHe5/tc-custom/9789948750154.jpg?1725723408958" alt="This image is the cover for the book صرخة ضمير ونغمة قلب"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">صرخة ضمير ونغمة قلب
      </h1>
      <p class="bookDescription body article font2">
        <p>أراكِ فأعجبُ أنتِ سماءٌ وعطرٌ وسكرٌ نبعُ عطاءٍ فكيف تكونُ حياةٌ بدونِكِ؟! فأنتِ السِّحرُ ومنكِ البهاءُ عيونُكِ صبحٌ غزاهُ شروقٌ ينشرُ ضوءًا عندَ المساءِ</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        حبر العناقيد
      </h2>
      
      <p class="authorDescription body article">إنسان عادي متواضع.. أحبَّ الخير لكلِّ الناس.. متزوّج ولديه أربعة أبناء صبيان وبنتان يعيشون في منزل صغير بالإيجار.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b815e1d